/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_water_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hot weather and illness increase your needs.`)
};

const es_water_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El calor y las enfermedades aumentan tus necesidades.`)
};

const de_water_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heißes Wetter und Krankheit erhöhen deinen Bedarf.`)
};

const nl_water_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warm weer en ziekte verhogen je behoefte.`)
};

const fr_water_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La chaleur et la maladie augmentent vos besoins.`)
};

const it_water_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il caldo e le malattie aumentano il tuo fabbisogno.`)
};

const pt_br2_water_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calor e doenças aumentam a sua necessidade.`)
};

const pt_water_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O calor e a doença aumentam as suas necessidades.`)
};

const ja_water_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暑い天候や体調不良は必要量を増加させます。`)
};

const zh_water_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`炎热天气和生病会增加饮水需求。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const water_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.water_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("water_ex3", locale)
	if (locale === "en") return en_water_ex3(inputs)
	if (locale === "es") return es_water_ex3(inputs)
	if (locale === "de") return de_water_ex3(inputs)
	if (locale === "nl") return nl_water_ex3(inputs)
	if (locale === "fr") return fr_water_ex3(inputs)
	if (locale === "it") return it_water_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_water_ex3(inputs)
	if (locale === "pt") return pt_water_ex3(inputs)
	if (locale === "ja") return ja_water_ex3(inputs)
	return zh_water_ex3(inputs)
};